import React, { useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import img1 from '../assets/images/bts1.jpg';
import img2 from '../assets/images/bts2.jpg';
import img3 from '../assets/images/bts3.jpg';
import img4 from '../assets/images/bts4.jpg';
import img5 from '../assets/images/bts5.jpg';
import img6 from '../assets/images/bts6.jpg';

function Process() {
  useEffect(() => {
    console.log("Process component mounted");
  }, []);

  console.log("Rendering Process section");

  return (
    <div className="bg-[#fdf4e4] py-16 px-6 md:px-24 text-[#3f3a32]">
      <div className="flex flex-col md:flex-row gap-10 text-left">

        {/* Left Section */}
        <div className="w-full md:w-1/2 space-y-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 font-mortend headings">A BLEND OF ART, HISTORY & INNOVATION.</h2>
          <div>
            <h3 className="text-lg font-semibold mb-1">
              Behind the Scenes
            </h3>
            <p className="text-base leading-relaxed">
            Sigiriya VR is crafted using Unreal Engine — one of the world’s most advanced real-time 3D creation tools. This powerful engine allows us to simulate the dynamic behavior of nature, from shimmering reflections on water surfaces to shadows that shift with the sun’s movement. Every structure, texture, and interaction is carefully modeled to deliver a cinematic, deeply immersive experience that brings the ancient world of Sigiriya to life like never before.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-1">Hardware Used</h4>
            <ul className="list-disc list-inside text-base space-y-1">
              <li>VR headsets: <strong>Meta Quest 3</strong></li>
              <li>Custom-Built PCs with <strong>RTX 4080 GPUs</strong> for high-fidelity rendering.</li>
            </ul>
          </div>
        </div>

        {/* Right Section: Image Carousel */}
        <div className="w-full md:w-1/2">
  <Carousel
    showThumbs={false}
    showStatus={false}
    infiniteLoop={true}
    autoPlay={true}
    interval={3000}
    swipeable={true}
    emulateTouch={true}
  >
    <div>
      <img src={img1} alt="Behind the Scenes 1" className="rounded-xl" />
    </div>
    <div>
      <img src={img2} alt="Behind the Scenes 2" className="rounded-xl" />
    </div>
    <div>
      <img src={img3} alt="Behind the Scenes 3" className="rounded-xl" />
    </div>
    <div>
      <img src={img4} alt="Behind the Scenes 4" className="rounded-xl" />
    </div>
    <div>
      <img src={img5} alt="Behind the Scenes 5" className="rounded-xl" />
    </div>
    <div>
      <img src={img6} alt="Behind the Scenes 6" className="rounded-xl" />
    </div>
  </Carousel>
</div>

      </div>
    </div>
  );
}

export default Process;
